import { ContentSubtype } from "./ContentSubtype";

export type TvSeriesContentSubtype = typeof tvSeriesContentSubtypes[number];

export const tvSeriesContentSubtypes = [ContentSubtype.TV] as const;

export const isTvSeriesContentSubtype = (contentType: number): contentType is TvSeriesContentSubtype =>
    tvSeriesContentSubtypes.includes(contentType);

export const ensureTvSeriesContentSubtype: (contentType: number) => asserts contentType is TvSeriesContentSubtype = (
    contentType: TvSeriesContentSubtype
) => {
    if (!tvSeriesContentSubtypes.includes(contentType)) {
        throw Error(`Content subtype should be TV Series'`);
    }
};
